export const getUrl = (callbackUrl: string, type: string) => {
  try {
    return new URL(callbackUrl);
  } catch {
    throw new Error(`'${callbackUrl}' is not a valid url for type '${type}'`);
  }
};
